module.exports = __webpack_public_path__ + "img/skip-button.1ed03c6a.png";